// extracted by mini-css-extract-plugin
module.exports = {"main":"Staff_main__6nM2D","submain":"Staff_submain__2hmrv","card":"Staff_card__lMNJR","titleMain":"Staff_titleMain__3WE5x"};